<template>
  <th
    data-sb-regression="sb-table-head"
    class="sb-table-head"
    scope="col"
  >
    <template v-if="$slots.default">
      <!--
        @slot slot to show table head column
      -->
      <slot />
    </template>
    <div class="sb-table-head__wrapper">
      <span
        v-if="!$slots.default"
        :title="headTitle"
      >
        {{ item.name }}
      </span>
      <SbSortableTableHead
        v-if="item && (item.sortingFn || item.sortable)"
        :item="item"
      />
    </div>
    <SbTooltip
      v-if="$slots.tooltip"
      variation="secondary"
      class="p1"
      orientation="top"
    >
      <!--
        @slot slot to show table head tooltip
      -->
      <slot name="tooltip" />
    </SbTooltip>
    <SbTooltip
      v-else-if="hasTooltip"
      variation="secondary"
      class="p1"
      orientation="top"
    >
      <SbText>{{ tooltipText }}</SbText>
    </SbTooltip>
  </th>
</template>
<script>
import SbTooltip from '@src/components/Tooltip/SbTooltip.vue';
import SbText from '@src/components/Text/SbText.vue';
import SbSortableTableHead from '@src/components/Table/components/SbSortableTableHead.vue';

export default {
  name: 'SbTableHead',
  components: { SbTooltip, SbText, SbSortableTableHead },
  props: {

    item: {
      type: Object,
      default: () => ({}),
    },

    tooltip: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  computed: {
    headTitle() {
      return this.hasTooltip ? '' : this.item.name;
    },
    hasTooltip() {
      return this.tooltip !== undefined || (this.item !== undefined && this.item.tooltip !== undefined);
    },
    tooltipText() {
      return this.tooltip || (this.item && this.item.tooltip);
    },
  },
};
</script>
<style lang="scss"></style>
